/* Behind the scent panel: opens from links to #behind-the-scent and draws the supply map. */
(function () {
  // Country positions on assets/behind-the-scent-map.svg (Equal Earth, 1000x486); generated from Natural Earth 110m.
  var COUNTRIES = {"fiji":[982.3,309.1],"tanzania":[596.1,266.3],"w. sahara":[467.6,153.7],"canada":[292.4,46.2],"united states of america":[257.1,100.5],"kazakhstan":[655.8,74],"uzbekistan":[654,94.4],"papua new guinea":[899,267.8],"indonesia":[816.3,244],"argentina":[335.8,368],"chile":[320.6,372.4],"dem. rep. congo":[565.4,253.6],"somalia":[626.5,225.3],"kenya":[604.8,240.8],"sudan":[581.2,183.7],"chad":[550.6,186.3],"haiti":[303.7,173],"dominican rep.":[309.6,173.1],"russia":[688.1,28.5],"bahamas":[293.3,152.9],"falkland is.":[366,421.6],"norway":[524.8,32.6],"greenland":[423.6,14.7],"fr. s. antarctic lands":[660,414.6],"timor-leste":[847.4,275.7],"south africa":[565.6,348.6],"lesotho":[573.2,351.1],"mexico":[228.2,155],"uruguay":[356.6,361.9],"brazil":[353.7,282.7],"bolivia":[324.3,305],"peru":[294.8,277.1],"colombia":[297.5,228.4],"panama":[279,211.2],"costa rica":[268.2,205.9],"nicaragua":[267,195.2],"honduras":[263.6,187.9],"el salvador":[256.9,192],"guatemala":[253.8,184.7],"belize":[259.2,179.3],"venezuela":[317.2,216.3],"guyana":[336.7,225.1],"suriname":[345.1,227.6],"france":[505.5,79.6],"ecuador":[282.6,248.4],"puerto rico":[320,175.5],"jamaica":[290.6,175.8],"cuba":[288.5,163.1],"zimbabwe":[580.5,313],"botswana":[563.6,324.4],"namibia":[545.9,324.3],"senegal":[460.4,189.7],"mali":[490.2,179.1],"mauritania":[472.1,168.4],"benin":[506.4,207.1],"niger":[525.2,178.7],"nigeria":[522,207.4],"cameroon":[534.9,221.9],"togo":[502.8,211.5],"ghana":[496.6,213.4],"côte d'ivoire":[484.5,214.8],"guinea":[469.6,204.1],"guinea-bissau":[458.5,198.2],"liberia":[474,219],"sierra leone":[467.5,211.2],"burkina faso":[495.1,197.2],"central african rep.":[556.3,218.6],"congo":[542,246.1],"gabon":[532.4,245.4],"eq. guinea":[528.7,236.8],"zambia":[576,292.8],"malawi":[593.6,291.9],"mozambique":[596.5,306.6],"eswatini":[582.7,340.1],"angola":[548,288.7],"burundi":[582.9,255.6],"israel":[590.2,128.5],"lebanon":[591.3,120.3],"madagascar":[626.1,314.4],"palestine":[590.7,127],"gambia":[457.8,192.9],"tunisia":[524.3,119.5],"algeria":[506.8,140.3],"jordan":[594.8,129.4],"united arab emirates":[644.2,155.2],"qatar":[635.4,150],"kuwait":[623.9,136],"iraq":[612,123.3],"oman":[650.8,167],"vanuatu":[955.2,299.5],"cambodia":[787.5,195.8],"thailand":[775.6,187.4],"laos":[780.8,174.8],"myanmar":[759.2,165.7],"vietnam":[789.1,181.6],"north korea":[812.3,99.7],"south korea":[821,111.8],"mongolia":[741.4,78.4],"india":[712.3,158.9],"bangladesh":[740.1,155.3],"bhutan":[737.4,142.6],"nepal":[719.7,139.7],"pakistan":[679.7,133.9],"afghanistan":[668.1,120.5],"tajikistan":[676.2,104.7],"kyrgyzstan":[681.6,95.2],"turkmenistan":[646.7,103],"iran":[639.6,125.1],"syria":[597.5,116.6],"armenia":[610.5,99.4],"sweden":[532.8,36.4],"belarus":[562.1,59.4],"ukraine":[572.1,71.7],"poland":[543.5,63.2],"austria":[532.8,76.4],"hungary":[545.2,77.6],"moldova":[566.5,77.6],"romania":[559,81.7],"lithuania":[552.2,54.5],"latvia":[553.5,50.4],"estonia":[554.7,45.7],"germany":[523.3,66.2],"bulgaria":[560.8,91.3],"greece":[555.7,102.3],"turkey":[587.5,103.2],"albania":[548.9,96.5],"croatia":[539.4,84.3],"switzerland":[519,78.8],"luxembourg":[513.7,70],"belgium":[510.4,67.4],"netherlands":[512.3,62.7],"portugal":[480.1,101.4],"spain":[491.1,99.1],"ireland":[482.1,60.3],"new caledonia":[944.1,321.5],"solomon is.":[939.3,272.5],"new zealand":[908.5,398.5],"australia":[854.7,337],"sri lanka":[722.8,214.3],"china":[759.2,110.8],"taiwan":[821.9,155.6],"italy":[529.7,89.2],"denmark":[520.2,52],"united kingdom":[494.3,58.6],"iceland":[462.8,30.3],"azerbaijan":[617,99.2],"georgia":[605.4,93.2],"philippines":[831.1,184.6],"malaysia":[817.8,229.7],"brunei":[818.2,225.5],"slovenia":[535.2,80.9],"finland":[552.3,32.2],"slovakia":[545.1,73],"czechia":[535.2,70],"eritrea":[605.5,185.7],"japan":[844.1,113.2],"paraguay":[344.2,328.5],"yemen":[629.4,183.9],"saudi arabia":[618.6,154.4],"antarctica":[638.2,484.5],"n. cyprus":[584.8,115.7],"cyprus":[583.7,116.9],"morocco":[477.4,134.3],"egypt":[578.6,145.9],"libya":[547.4,144.1],"ethiopia":[609.1,210.8],"djibouti":[616.7,199.2],"somaliland":[627.3,206.6],"uganda":[589.7,238.2],"rwanda":[583,250.5],"bosnia and herz.":[542.6,86.9],"macedonia":[552.8,95],"serbia":[549.8,86.7],"montenegro":[546.6,91.2],"kosovo":[550.5,91.9],"trinidad and tobago":[331.2,204.1],"s. sudan":[583.4,215.8],"usa":[257.1,100.5],"united states":[257.1,100.5],"us":[257.1,100.5],"uk":[494.3,58.6],"great britain":[494.3,58.6],"england":[494.3,58.6],"the netherlands":[512.3,62.7],"holland":[512.3,62.7],"czech republic":[535.2,70],"ivory coast":[484.5,214.8],"bosnia and herzegovina":[542.6,86.9],"dominican republic":[309.6,173.1],"monaco":[517.8,88.2],"san marino":[529.8,87.6],"malta":[536.3,113.6],"singapore":[787.9,238],"andorra":[503.7,92.1],"liechtenstein":[522.3,77.7],"mauritius":[654.9,318],"comoros":[618.9,286.6],"hong kong":[805.3,160.8],"bahrain":[633.3,147.4]};

  var MAP_W = 1000;
  var MAP_H = 486;
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function lookup(name) {
    return COUNTRIES[String(name || '').trim().toLowerCase()] || null;
  }

  function el(tag, attrs) {
    var node = document.createElementNS(SVG_NS, tag);
    for (var key in attrs) node.setAttribute(key, attrs[key]);
    return node;
  }

  function drawMap(dialog) {
    var map = dialog.querySelector('.bts__map');
    var svg = dialog.querySelector('.bts__map-svg');
    var routes = svg.querySelector('.bts__routes');
    var pins = svg.querySelector('.bts__pins');
    var steps = Array.prototype.slice.call(dialog.querySelectorAll('.bts__step'));
    routes.textContent = '';
    pins.textContent = '';

    var made = null;
    var places = {};
    steps.forEach(function (step) {
      var name = step.dataset.country;
      var point = lookup(name);
      if (!point) {
        if (name) console.warn('Behind the scent: unknown country "' + name + '"');
        return;
      }
      var key = name.trim().toLowerCase();
      if (!places[key]) places[key] = { name: name.trim(), point: point };
      step.dataset.place = key;
      if (step.classList.contains('bts__step--made')) made = places[key];
    });

    var list = Object.keys(places).map(function (k) { return places[k]; });
    map.hidden = !list.length;
    if (!list.length) return;

    // Fit the view around the points, at the svg's on-screen ratio.
    var rect = svg.getBoundingClientRect();
    var ratio = rect.width && rect.height ? rect.height / rect.width : 0.75;
    var xs = list.map(function (p) { return p.point[0]; });
    var ys = list.map(function (p) { return p.point[1]; });
    var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
    var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
    var w = Math.max(maxX - minX + 160, 240);
    var h = Math.max(maxY - minY + 120, w * ratio);
    w = Math.max(w, h / ratio);
    if (w > MAP_W) { w = MAP_W; h = w * ratio; }
    var x = Math.min(Math.max((minX + maxX) / 2 - w / 2, 0), MAP_W - w);
    var y = Math.min(Math.max((minY + maxY) / 2 - h / 2, 0), Math.max(MAP_H - h, 0));
    svg.setAttribute('viewBox', [x, y, w, h].map(function (n) { return n.toFixed(1); }).join(' '));

    // Sizes are given in screen pixels and converted to map units, so they look the same on every screen.
    var px = w / (rect.width || 600);
    var r = 4 * px;
    var fontSize = 10 * px;
    var gap = 7 * px;

    // Labels go right of the pin; if that collides with an earlier label, try left, then shift down.
    var boxes = [];
    function collides(b) {
      return boxes.some(function (o) {
        return b.x1 < o.x2 && b.x2 > o.x1 && b.y1 < o.y2 && b.y2 > o.y1;
      });
    }
    list.forEach(function (place) {
      var isMade = place === made;
      var pr = isMade ? r * 1.5 : r;
      var g = el('g', { class: 'bts__pin-group' });
      g.dataset.place = place.name.toLowerCase();
      g.appendChild(el('circle', {
        cx: place.point[0], cy: place.point[1], r: pr,
        class: 'bts__pin' + (isMade ? ' bts__pin--made' : '')
      }));
      boxes.push({ x1: place.point[0] - pr, x2: place.point[0] + pr, y1: place.point[1] - pr, y2: place.point[1] + pr });
      pins.appendChild(g);
      place.group = g;
      place.radius = pr;
    });
    list.forEach(function (place) {
      var tw = place.name.length * fontSize * 0.68;
      var px0 = place.point[0], py0 = place.point[1];
      var options = [];
      for (var shift = 0; shift < 4; shift++) {
        var dy = shift * fontSize * 1.1;
        options.push({ anchor: 'start', x: px0 + place.radius + gap * 0.6, y: py0 + dy });
        options.push({ anchor: 'end', x: px0 - place.radius - gap * 0.6, y: py0 + dy });
        options.push({ anchor: 'start', x: px0 + place.radius + gap * 0.6, y: py0 - dy });
        options.push({ anchor: 'end', x: px0 - place.radius - gap * 0.6, y: py0 - dy });
      }
      var chosen = options[0], box;
      for (var i = 0; i < options.length; i++) {
        var o = options[i];
        box = { x1: o.anchor === 'start' ? o.x : o.x - tw, x2: o.anchor === 'start' ? o.x + tw : o.x, y1: o.y - fontSize * 0.55, y2: o.y + fontSize * 0.55 };
        var inside = box.x1 >= x + gap * 0.3 && box.x2 <= x + w - gap * 0.3 && box.y1 >= y && box.y2 <= y + h;
        if (inside && !collides(box)) { chosen = o; break; }
      }
      boxes.push(box);
      var label = el('text', {
        x: chosen.x, y: chosen.y + fontSize * 0.35, 'text-anchor': chosen.anchor,
        class: 'bts__pin-label', 'font-size': fontSize
      });
      label.textContent = place.name;
      place.group.appendChild(label);
    });

    // Routes from every origin to where the candle is made. Each bends below the straight line,
    // unless that crosses another pin or label more than bending above would.
    if (made) {
      var margin = 3 * px;
      var hits = function (a, c, b) {
        var count = 0;
        for (var t = 0.1; t <= 0.9; t += 0.05) {
          var u = 1 - t;
          var qx = u * u * a[0] + 2 * u * t * c[0] + t * t * b[0];
          var qy = u * u * a[1] + 2 * u * t * c[1] + t * t * b[1];
          boxes.forEach(function (o) {
            if (qx > o.x1 - margin && qx < o.x2 + margin && qy > o.y1 - margin && qy < o.y2 + margin) count++;
          });
        }
        return count;
      };
      list.forEach(function (place, i) {
        if (place === made) return;
        var a = place.point, b = made.point;
        var mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2;
        var nx = -(b[1] - a[1]), ny = b[0] - a[0];
        if (ny < 0) { nx = -nx; ny = -ny; }
        var down = [mx + nx * 0.2, my + ny * 0.2];
        var up = [mx - nx * 0.2, my - ny * 0.2];
        var c = hits(a, up, b) < hits(a, down, b) ? up : down;
        var path = el('path', {
          d: 'M' + a[0] + ',' + a[1] + ' Q' + c[0] + ',' + c[1] + ' ' + b[0] + ',' + b[1],
          class: 'bts__route',
          'stroke-width': 1 * px
        });
        path.dataset.place = place.name.toLowerCase();
        routes.appendChild(path);
        path.style.setProperty('--bts-length', path.getTotalLength());
        path.style.setProperty('--bts-i', i);
      });
    }

    // Hovering a step highlights its country on the map.
    steps.forEach(function (step) {
      if (!step.dataset.place || step.dataset.hover) return;
      step.dataset.hover = 'true';
      step.addEventListener('mouseenter', function () {
        map.classList.add('is-highlighting');
        svg.querySelectorAll('[data-place]').forEach(function (node) {
          node.classList.toggle('is-active', node.dataset.place === step.dataset.place);
        });
      });
      step.addEventListener('mouseleave', function () {
        map.classList.remove('is-highlighting');
      });
    });
  }

  function open() {
    var dialog = document.getElementById('behind-the-scent');
    if (!dialog) return;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('bts-open');
    // draw after opening so the map has its on-screen size
    drawMap(dialog);
  }

  // One document-level listener; the dialog is looked up on click so section reloads in the editor keep working.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href$="#behind-the-scent"]');
    if (!link || !document.getElementById('behind-the-scent')) return;
    event.preventDefault();
    open();
  });

  function init() {
    var dialog = document.getElementById('behind-the-scent');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';

    dialog.querySelector('.bts__close').addEventListener('click', function () { dialog.close(); });
    // click on the backdrop area closes
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('bts-open');
    });
    // the theme stops Escape before the dialog sees it, so close explicitly
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        dialog.close();
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (dialog.open) drawMap(dialog);
      }, 150);
    });

    if (window.location.hash === '#behind-the-scent') open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
